// extracted by mini-css-extract-plugin
export default {"logosHolder":"LogosFooter_logosHolder__ktFE6"};